/**
 * Type guards for StockClassDemandTemplateAutocomplete options.
 *
 * These helpers are separated from StockClassDemandTemplateAutocomplete.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { DefaultStockClassDemandTemplate } from "model";

export type StockClassDemandTemplateAutocompleteOption =
  Required<DefaultStockClassDemandTemplate> & {
    stockClassName: string;
    feedingName: string;
    firstLetter: string;
  };

export type UserInputOption = {
  inputValue: string;
  title: string;
};

export type AutocompleteOption = StockClassDemandTemplateAutocompleteOption;
export type FilteredAutocompleteOption = AutocompleteOption | UserInputOption;
export type SelectedAutocompleteOption = FilteredAutocompleteOption | string;

export function instanceOfStockClassDemandTemplateAutocompleteOption(
  object: unknown
): object is StockClassDemandTemplateAutocompleteOption {
  return typeof object === "object" && object !== null && "name" in object;
}

export function instanceOfUserInputOption(
  object: unknown
): object is UserInputOption {
  return (
    typeof object === "object" && object !== null && "inputValue" in object
  );
}
